import { v4 as uuid } from 'uuid';

import { VoiceboxDescribeRequestMessage } from 'src/utils/voicebox/types';

export const createDescribeRequestMessage = ({
  code,
  turtleResponseMessageId,
}: {
  code: string;
  turtleResponseMessageId: string;
}): VoiceboxDescribeRequestMessage => ({
  role: 'user',
  isDescribeRequest: true,
  turtleResponseMessageId,
  code,
  content: `Describe the last ontology in 3 sentences in english`,
  id: uuid(),
});
